import styles from "./CodeStatus.module.css";

/** On a printed sheet, in place of a code that isn't ready (the browser's own print can't be held back). */
export const CODE_NOT_READY = "Code not ready: print again in a moment.";
export const CODE_FAILED = "Code couldn’t load: reload the page and print again.";

/**
 * In place of a QR code or barcode while it's drawn (bwip-js loads on demand), about the code's size so the page jumps
 * little. A spinner, not a sample code, so nobody tries to scan it.
 */
export function CodeLoading({ shape }: { shape: "qr" | "barcode" | "square" }) {
  return (
    <div className={`${styles.loading} ${styles[shape]}`} role="img" aria-label="Loading">
      <span className={styles.spinner} />
    </div>
  );
}

/** When bwip-js couldn't load: reloading is the way back, since a browser may not fetch a failed import again. */
export function CodeError({ what }: { what: string }) {
  return (
    <p className={styles.error} role="alert">
      Couldn&rsquo;t load {what}.{" "}
      <button type="button" className="btn btn--ghost" onClick={() => window.location.reload()}>
        Reload the page
      </button>
    </p>
  );
}

/**
 * Print, once the sheet's codes are ready. It's open again if they can't load (a blocker may stop them for good), since
 * the rest of the sheet is still useful, and the sheet says the code is missing.
 */
export function PrintButton({ ready, failed }: { ready: boolean; failed: boolean }) {
  return (
    <>
      <button type="button" className="btn btn--ghost" disabled={!ready && !failed} onClick={() => window.print()}>
        {ready || failed ? "Print" : "Preparing…"}
      </button>
      {failed && <CodeError what="the codes for printing" />}
    </>
  );
}
